import { createContext, useContext, useState, ReactNode } from 'react';
import SelecionaParceiroFilhoModal from '../components/Modals/SelecionaParceiroFilhoModal';

type SelecionaParceiroFilhoModalContextType = {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  parceiro: null | { id: number; nome: string };
  setParceiro: any;
};

const SelecionaParceiroFilhoModalContext =
  createContext<SelecionaParceiroFilhoModalContextType | null>(null);

export function SelecionaParceiroFilhoModalProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [parceiro, setParceiro] = useState<null | { id: number; nome: string }>(
    null,
  );

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <SelecionaParceiroFilhoModalContext.Provider
      value={{ isOpen, openModal, closeModal, parceiro, setParceiro }}
    >
      {children}
      <SelecionaParceiroFilhoModal />
    </SelecionaParceiroFilhoModalContext.Provider>
  );
}

export function useSelecionaParceiroFilhoModal() {
  const context = useContext(SelecionaParceiroFilhoModalContext);

  if (!context) {
    throw new Error('useModal must be used within ModalProvider');
  }

  return context;
}
